export type ErrorData = {
  success?: boolean;
  message: string;
  data?: {
    id: string;
    domain: string;
    timestamp: string;
  };
};

export type ApiError = {
  status: number;
  data: ErrorData;
};

export class ApiErrorClass extends Error {
  data: ErrorData;
  status?: number;

  constructor(data: ErrorData, status?: number) {
    super(data.message);
    this.name = "ApiError";
    this.data = data;
    this.status = status;
  }
}
